import React, { useEffect, useState } from 'react';

import { DefaultHTMLSwornDeclaration } from '../DefaultHTMLSwornDeclaration';
import { DeclarationDynamicForm } from '../DeclarationDynamicForm';

export interface WriteSwornDeclarationFormProps {
  watch?: any;
  showRepresentativeRestaurantAddress?: boolean;
  showRestaurantNameAddress?: boolean;
  children?: React.ReactNode;
}

export const WriteSwornDeclarationForm = ({
  watch,
  showRepresentativeRestaurantAddress,
  showRestaurantNameAddress,
  children
}: WriteSwornDeclarationFormProps) => {
  const [firstName, lastName, restaurantName, address, date, suppliers, company] = watch([
    'firstName',
    'lastName',
    'address',
    'restaurantName',
    'date',
    'suppliers',
    'company'
  ]);

  const [suppliersState, setSuppliersState] = useState(suppliers || []);

  useEffect(() => {
    setSuppliersState(suppliers || []);
  }, [suppliers]);

  return (
    <div className="xl:grid flex flex-col grid-cols-8 gap-5">
      <div className="col-span-3">
        <DeclarationDynamicForm
          showRepresentativeRestaurantAddress={showRepresentativeRestaurantAddress}
          showRestaurantNameAddress={showRestaurantNameAddress}
        />
        {children}
      </div>
      <div className="col-span-5">
        <DefaultHTMLSwornDeclaration
          firstName={firstName || ''}
          lastName={lastName || ''}
          restaurantName={restaurantName || ''}
          address={address || ''}
          date={date || new Date().toISOString()}
          suppliers={suppliersState}
          company={company || ''}
        />
      </div>
    </div>
  );
};
